import { disableRecordingModeration, enableRecordingModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } from './slice';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
/**
 * Registers a change handler for state['features/base/conference'].conference
 * to set the event listeners needed for the recording moderation feature to operate.
 */
StateListenerRegistry.register((state) => state['features/base/conference'].conference, (conference, { dispatch }, previousConference) => {
    if (conference && !previousConference) {
        // When a participant is approved for recording
        conference.on(JitsiConferenceEvents.RECORDING_MODERATION_APPROVED, ({ requestOccupantJid }) => {
            dispatch(localParticipantApproved());
        });
        // When a participant is rejected for recording
        conference.on(JitsiConferenceEvents.RECORDING_MODERATION_REJECTED, () => {
            dispatch(localParticipantRejected());
        });
        // When the recording moderation state changes (enabled/disabled)
        conference.on(JitsiConferenceEvents.RECORDING_MODERATION_CHANGED, ({ enabled, actor }) => {
            enabled ? dispatch(enableRecordingModeration(actor)) : dispatch(disableRecordingModeration(actor));
        });
        // When a specific participant is approved for recording
        conference.on(JitsiConferenceEvents.RECORDING_MODERATION_PARTICIPANT_APPROVED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantApproved({ jid }));
        });
        // When a specific participant is rejected for recording
        conference.on(JitsiConferenceEvents.RECORDING_MODERATION_PARTICIPANT_REJECTED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantRejected({ jid }));
        });
    }
});
